import { toNumber } from '../../../../utils/helper/lodash_replacements';
export class AttachedTraitActive {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get at() {
        return this.parent;
    }
    get trait() {
        return this.at.trait;
    }
    // @computed
    get isAtEnabled() {
        if (!this.at.reg)
            return false;
        return this.at.reg.isEnabled({ at: this.at, aspect: this.at.aspect });
        /*  if (this.at.reg.isAlwaysEnabled) return true;
        if (this.at.attachedCondition.isConditionTrue) return true;
        return false; */
    }
    // @computed
    get isAtActive() {
        const activeAts = this.at.aspect.activesOf[this.at.key];
        return activeAts.includes(this.at);
    }
    // @computed
    get prio() {
        let p = toNumber(this.trait.traitPriority.priority);
        if (this.at.attachedImport.isTraitImportedFromExternal) {
            p = p - 1000 + this.at.attachedImport.exportingPriorityLevel;
        }
        return p;
    }
}
